import React, { PropsWithChildren } from 'react';
import { screenMargin, smallestMargin, subtitleFontSize } from '_utils/sizes';
import { useThemeContext } from '_utils/themeContext';
import HeimeText from 'Components/HeimeText';

const CategoryTitle = ({ children }: PropsWithChildren<unknown>) => {
    const { theme } = useThemeContext();
    return (
        <HeimeText
            style={{
                marginLeft: screenMargin,
                marginRight: screenMargin,
                marginBottom: smallestMargin,
                fontWeight: 'bold',
                fontSize: subtitleFontSize,
                color: theme.shadowText,
            }}
        >
            {children}
        </HeimeText>
    );
};

export default CategoryTitle;
